module.exports = __webpack_public_path__ + "img/left.dc8cd07e.png";